import { BannerCarousel, CommonSelect, CommonToolTip, CstmPagination } from 'components/Common/Common'
import ErrorComponent from 'components/shared/ErrorComponent'
import LoadingIndicator from 'components/shared/LoadingIndicator'
import LoadingOverlay from 'components/shared/LoadingOverlay'
import TableLayoutV2 from 'components/TableLayoutV2'
import { GRADE_OPTIONS } from 'config/constants'
import { TASK_PLANS_LIST } from 'config/paths'
import { dateFormat, userFullName } from 'helpers/common'
import { debounce } from 'lodash'
import React, { useCallback, useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Download } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { generatePath, useNavigate } from 'react-router-dom'
import { useGetDownloadListQuery, useLazyDownloadFileQuery } from 'store/services/downloadCenter'
import { supportStaffFilter } from 'store/slices/filter'


function DownloadCenter() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const filter = useSelector(state => state?.filter?.supportStaffFilter);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const { data: downloadList, isLoading, isError, isFetching } = useGetDownloadListQuery({ page: currentPage, limit: pageSize, ...filter })
  const totalRecords = downloadList?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);
  const [downloadFile, { isFetching: getFileFetching }] = useLazyDownloadFileQuery();

  const handleDownloadFile = async (id) => {
    try {
      const response = await downloadFile({ id }).unwrap();
      window.open(response?.download_url, '_blank');
    } catch (error) {
      console.error("Error downloading file", error);
    }
  }


  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };


  const handleFilterChange = (key) => (value) => {
    dispatch(supportStaffFilter({ ...filter, [key]: value }))
    setCurrentPage(1);
  };

  const column = [
    // {
    //   head: <div onClick={() => dispatch(taskPlanFilter({ ...filter, sort: filter?.sort?.column == "is_favorite" ? { column: "id", direction: "ASC" } : { column: "is_favorite", direction: "desc" } }))}>{filter?.sort?.column == "is_favorite" ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div>,
    //   accessor: "is_favorite",
    //   isComponent: true,
    //   component: (item, ind) => (
    //     <h6 className="m-0 text-capitalize d-flex align-items-center gap-2">
    //       <div className="cursor-pointer" onClick={(e) => {
    //         e.stopPropagation();
    //         handleFavouriteReport(item?.assesmentResources?.id, item?.is_favorite ? 0 : 1)
    //       }}>
    //         {item?.is_favorite ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}
    //       </div>
    //     </h6>
    //   ),
    // },
    {
      head: "DATE",
      accessor: "date",
      isComponent: true,
      sorter: true,
      component: (item) => dateFormat(item?.createdAt, "MMM DD, YYYY"),
    },
    {
      head: "TOTAL REPORTS",
      accessor: "total_reports",
      isComponent: true,
      sorter: true,
      width: "10%",
      component: (item) => {
        return (
          <h6 className="m-0 text-capitalize d-flex align-items-center gap-2">
            {item?.total_reports || "--"}
          </h6>
        )
      }
    },
    {
      head: "PROCESSED REPORTS",
      accessor: "processed_reports",
      isComponent: true,
      sorter: true,
      width: "10%",
      component: (item) => {
        return (
          <h6 className="m-0 text-capitalize d-flex align-items-center gap-2">
            {item?.processed_reports || "--"}
          </h6>
        )
      }
    },
    {
      head: "ERROR",
      accessor: "error_message",
      isComponent: true,
      sorter: true,
      width: "100%",
      component: (item) => {
        return (
          <div>
            <CommonToolTip
              text={item?.error_message || "N/A"}
              component={
                <div className="cell-text-ellipsis">{item?.error_message || "N/A"}</div>
              }
            />
          </div>
        )
      },
    },
    {
      head: "STATUS",
      accessor: "status",
      isComponent: true,
      sorter: true,
      width: "100%",
      component: (item) => {
        return (
          <div>
            <span style={{ textTransform: "capitalize" }}>{item?.status || "N/A"}</span>
          </div>
        )
      },
    },
    {
      head: "SCHOOL NAME",
      accessor: "school_name",
      isComponent: true,
      sorter: true,
      width: "100%",
      component: (item) => {
        return (
          <h6 className="m-0 text-capitalize d-flex align-items-center gap-2">
            {item?.school_name || "--"}
          </h6>
        )
      }
    },
    {
      head: "",
      accessor: "download",
      isComponent: true,
      // sorter: true,
      component: (item) => {
        return (
          item?.status == "completed" &&
          <Download style={{ cursor: "pointer" }} onClick={() => handleDownloadFile(item?.id)} color='#93278f' />
        )
      }
    },
  ];

  const handleSearchChange = useCallback(debounce((value) => {
    handleFilterChange("search")(value);
  }, 500), [handleFilterChange, 500]);

  return (
    <>
      <section className='client position-relative py-4 px-2 min-vh-100' style={{ background: "#3DA0AA0D" }}>
        <Container fluid>
          {(isLoading) ? (
            <div style={{ height: "200px" }}>
              <LoadingIndicator />
            </div>
          ) : (
            <Col className='col-lg-11'>
              {/* <CaseloadSchool caseloadData={caseloadSchoolData?.record} /> */}
              <div style={{ justifyContent: 'space-between' }} className='left classroom-conslutation d-flex justify-content-between align-items-end mt-4'>
                <h6 className="m-0 fw-bold main-head">Download Center</h6>
                <Col xs="4" md='4'>
                  {/* <div className="reports-v2 d-flex w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0 text-end">SEARCH</label>
                    <input
                      type="text"
                      style={{ borderRadius: "8px", height: "30px" }}
                      placeholder='Type to search...'
                      className="read-only form-control w-100"
                      onChange={(e) => handleSearchChange(e.target.value)}
                    />
                  </div> */}
                </Col>
              </div>

              <div className="table-outer mt-3">
                {isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {(isFetching || getFileFetching) && <LoadingOverlay />}
                    <TableLayoutV2
                      data={downloadList?.records || []}
                      column={column}
                      filter={filter}
                      handleSort={handleFilterChange("sort")}
                    // handleGetRowColor={handleGetRowColor}
                    />
                  </>
                )}
                <CstmPagination
                  totalPages={totalPages}
                  className={'paginationV2'}
                  activePage={currentPage}
                  handlePageChange={handlePageChange}
                />
              </div>
            </Col>
          )}
        </Container>
      </section>
    </>
  )
}

export default DownloadCenter
